import type * as React from "react";
import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { Loading03Icon } from "@hugeicons/core-free-icons";

/* O tipo vem do próprio ícone: `ComponentProps<"svg">` deixa `width` como
   `string | number` e o Hugeicons só aceita número. */
function Spinner({ className, ...props }: Omit<React.ComponentProps<typeof HugeiconsIcon>, "icon">) {
  return (
    <HugeiconsIcon
      icon={Loading03Icon}
      strokeWidth={2}
      data-slot="spinner"
      role="status"
      /* "Loading" é o que o registro traz, e é o que um leitor de tela brasileiro
         anunciava no meio de uma mesa inteira em português. Nome acessível é
         CONTEÚDO, não tema — mas mora aqui porque é o padrão de todas as rodas
         da mesa, e quem tem uma espera específica passa a sua por `aria-label`
         (a trilha de acesso e a ativação já passam). Se `shadcn add --overwrite`
         reescrever este arquivo, esta linha é a que precisa voltar. */
      aria-label="Carregando"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
